<app-toaster></app-toaster>
<div *ngIf="!version" class="alert alert-danger" contenteditable="false">
    <div class="version-message text-danger">
        <h3 class="mt-2">
            Your browser is currently rendering an older version of the UI.
        </h3>
        <button type="button" class="btn btn-success ms-1" (click)="reload()">Update</button>
    </div>
</div>
<div class="admin-view h-100" contenteditable="false">
    <router-outlet></router-outlet>
</div>